import { render, staticRenderFns } from "./SurchargeEditForm.vue?vue&type=template&id=f67b799a&scoped=true&"
import script from "./SurchargeEditForm.vue?vue&type=script&lang=js&"
export * from "./SurchargeEditForm.vue?vue&type=script&lang=js&"
import style0 from "./SurchargeEditForm.vue?vue&type=style&index=0&id=f67b799a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f67b799a",
  null
  
)

export default component.exports